export const QUERY_KEYS = {
  CARDS: "CARDS",
  ADMIN_USERS: "ADMIN_USERS",
  ADMIN_COMMISSIONS: "ADMIN_COMMISSIONS",
};
